import type { ChatThread } from "types/ChatThread";
import type { Message } from "types/Message";
import { postThread } from "services/dbApi/methods/postThread";
import { putThreadMessages } from "services/dbApi/methods/putThreadMessages";
import httpErrorStatus from "utilities/httpErrorStatus";

/**
 * Re-runs the new-chat persist sequence for an already-chosen thread id, for
 * the MessagesWriteError retry (ADR 065. Uses the raw request methods, not the
 * React Query mutations, because the mutation observers are torn down when the
 * boundary unmounts NewChat. `POST /threads` is not idempotent — a repeat POST
 * of the captured id returns 409 — so a 409 is treated as "thread already
 * exists, proceed" rather than an error.
 */
export async function persistNewChat(
  thread: ChatThread,
  messages: Message[],
  getAccessToken: () => Promise<string>
): Promise<void> {
  // `POST /threads` is not idempotent. Repeating this request for an already
  // existing thread returns 409 "thread already exists".
  try {
    await postThread(thread, getAccessToken);
  } catch (err) {
    if (httpErrorStatus(err) !== 409) throw err;
  }
  await putThreadMessages(thread.id, messages, getAccessToken);
}
